import React, {PureComponent} from 'react';
import NativeSelect from '@mui/material/NativeSelect';


const data = [{key: 1, mes: "Enero"},
              {key: 2, mes: "Febrero"},
              {key: 3, mes: "Marzo"},
              {key: 4, mes: "Abril"},
              {key: 5, mes: "Mayo"},
              {key: 6, mes: "Junio"},
              {key: 7, mes: "Julio"},
              {key: 8, mes: "Agosto"},
              {key: 9, mes: "Septiembre"},
              {key: 10, mes: "Octubre"},
              {key: 11, mes: "Noviembre"},
              {key: 12, mes: "Diciembre"},
            ]

export class MonthFilter extends PureComponent{
    render() {
        return(
            <div name="monthFilter">
                <h5>Mes
                <NativeSelect style={{width: '50%', padding: '2px', marginTop: '2px', marginLeft: '10px'}}
                              defaultValue={2}
                              onChange={e => this.props.handleChangemonth(e)}
                              inputProps={{
                                  name: 'key',
                                  id: 'uncontrolled-native',
                              }}>
                    {data.map(item => <option value={item.key} key={item.key}>{item.mes}</option>)}
                </NativeSelect>
                </h5>
            </div>
        )
    }
}